import {post, get} from '@/utils/request'

export function getListAPI(data) {
	return post({
		data,
		url: 'tbs/check/list'
	})
}

export function getStatAPI(data) {
	return post({
		data,
		url: 'tbs/check/stat',
	})
}

export function getVoucherAPI(billMonth) {
	return get({
		url: `tbs/check/voucher/${billMonth}`,
	})
}

export function addVoucherAPI(data) {
	return post({
		data,
		url: 'tbs/check/voucher',
	})
}

export function checkStatusAPI(billMonth) {
	return get({
		url: `tbs/check/check-status/${billMonth}`,
	})
}